<template>
    <div class="column additonal-info-place modal">
        
        <form @submit.prevent class="form box ">
            <button 
                @click="closeModal"
                class="button ml-3 is-secondary has-text-weight-bold is-danger is-pulled-right">
                <span class="icon"><i class="fas fa-times"></i></span>
            </button>
            
            <div class="additonal-info">
                
                <h1 class="title mb-0 is-3">Incident</h1>
                <div class="content is-medium">
                    <p>Do you want to describe the incident? </p>
                </div>

                <div class="field">
                    <label for="description" class="label is-large is-tight">What Happened?</label>
                    <div class="control">
                        <textarea v-model="description" class="textarea is-medium" placeholder="Any detail is useful"></textarea>
                    </div>
                </div>

                <div class="buttons mt-5  is-right">

                    <button v-if="description"
                        @click="startSubmitAdditionalDetails"
                        :class="{'is-loading':is_loading || !current_user}"
                        class="button is-primary is-large has-text-weight-bold">
                        DONE
                    </button>

                    <button v-else
                        @click="$router.push('/')"
                        :class="{'is-loading':is_loading || !current_user}"
                        class="button is-primary is-light is-large has-text-weight-bold">
                        SKIP
                    </button>

                </div>
            

            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters,mapActions } from "vuex";

export default {
    props: {
        registration: String
    },
    data() {
        return {
            description: null
        }
    },
    computed: {
        ...mapGetters({
            is_loading: "is_loading",
            current_user: "current_user"
        }),
    },
    methods: {
        ...mapActions({
            updateRegistration: "updateRegistration",
            loading: "loading",
            setMessage: 'setMessage'
        }),
        startSubmitAdditionalDetails() {
            this.loading(true)
            var submission = { 
                number_plate: this.registration,
                details: { description: this.description, },
            }
            this.updateRegistration(submission).then(()=>{
                
            }).catch(()=>{
                this.loading(false)
            })
        },
        closeModal() {
            this.setMessage({text:"Number plate registration "+ this.registration + " has been sucessfully nominated",type:'is-success'})
            this.$router.push('/')
        }
    }
}
</script>